import store from '@/store'
import { hasAnyPermissionCode } from '@/utils/permission'

// v-permission="'device:add'" 或 v-permission="['device:add', 'device:update']"
// 当前登录人没有该权限时，直接移除按钮节点
function checkPermission(el, binding) {
  const codes = binding.value
  if (!codes) return
  if (hasAnyPermissionCode(store.state.userInfo, codes)) return
  el.parentNode && el.parentNode.removeChild(el)
}

export default {
  install(Vue) {
    Vue.directive('permission', {
      inserted: checkPermission
    })
  }
}
